module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages",
    style: ([
      _vm.style.longestHeight,
      _vm.style.messagesWrapper ]),
    attrs: {
      "id": "messages"
    }
  }, [_c('div', {
    staticClass: "messages__wrapper",
    style: ({
      '--loaderDuration': _vm.transitionDuration / _vm.messages.length + 'ms',
      '--offsetTop': _vm.maxSentenceHeight + 'px',
    }),
    attrs: {
      "id": "messagesWrapper"
    }
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: index,
      class: [
        'messages__message',
        ("messages__message--" + index),
        {
          'active': index === 0,
          'finished': _vm.messages.length === 1
        }
      ],
      style: (_vm.heightFetched ? _vm.style.message : ''),
      attrs: {
        "id": [
          message === _vm.longestSentence ? 'longestSentence' : '' ]
      }
    }, [_c('h2', {
      staticClass: "h2 mt0 mb0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(message))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abdb31d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/LoaderMessages.vue
// module id = 285
// module chunks = 2